import Child from "./Child";

export default function ChildList({ childs }) {
  return childs.map((child) => <Child key={child.id} child={child} />);
}
